"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const core_1 = require("@material-ui/core");
const Grid_1 = require("@material-ui/core/Grid");
const styles_1 = require("@material-ui/core/styles");
const color = require("color");
const lodash_1 = require("lodash");
const React = require("react");
const react_i18next_1 = require("react-i18next");
const ArcadeCurrency_1 = require("../card/ArcadeCurrency");
const InformationDialog_1 = require("../dialog/InformationDialog");
const ArcadeNotification_1 = require("./ArcadeNotification");
const ArcadePopupButton_1 = require("./ArcadePopupButton");
const WagerQuantity_1 = require("./WagerQuantity");
const ArcadeDetails = ({ redeemablePoints, denominations, selectedWagerIndex, updateWager, launchGame, launchFunGame, playForFun, t, classes, howToPlayText, logo, isLoggedIn }) => {
    if (denominations.length === 1) {
        updateWager(0);
    }
    const playForFunContainer = () => playForFun ? ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: classes.forFunContainer }, { children: (0, jsx_runtime_1.jsx)(core_1.Button, Object.assign({ variant: 'text', color: 'secondary', className: classes.detailButton, onClick: launchFunGame }, { children: t('arcade.button.playForFun') })) }))) : null;
    const howToPlayContainer = () => ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: classes.howtoPlayButton }, { children: (0, jsx_runtime_1.jsx)(core_1.Button, Object.assign({ variant: 'contained', color: 'secondary', className: classes.howToPlayBg, onClick: showHowToPlay, "aria-label": "how to play", disabled: false }, { children: t('arcade.button.howToPlay') })) })));
    const [howToPlay, setHowToPlay] = React.useState(false);
    const showHowToPlay = () => setHowToPlay(true);
    const hideHowToPlay = () => setHowToPlay(false);
    const renderLogo = () => ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: classes.logoContainer }, { children: (0, jsx_runtime_1.jsx)("img", { src: logo, alt: "logo", style: {
                width: '100%',
                height: '100%'
            } }) })));
    const showPlayButtons = isLoggedIn === false || redeemablePoints >= denominations[selectedWagerIndex].value;
    const showWagerButtons = isLoggedIn === false || redeemablePoints >= denominations[0].value;
    return ((0, jsx_runtime_1.jsxs)(Grid_1.default, Object.assign({ item: true, xs: 12, style: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center'
        } }, { children: [renderLogo(), showWagerButtons ? ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: classes.detailBtnContainer }, { children: [howToPlayContainer(), denominations.length > 1 ? ((0, jsx_runtime_1.jsx)(WagerQuantity_1.default, { items: (0, lodash_1.map)(denominations, 'value'), defaultIndex: selectedWagerIndex, onUpdate: updateWager })) : null, showPlayButtons ? ((0, jsx_runtime_1.jsxs)(React.Fragment, { children: [(0, jsx_runtime_1.jsxs)("div", Object.assign({ className: classes.winningAmount }, { children: [(0, jsx_runtime_1.jsx)(core_1.Typography, Object.assign({ variant: "subtitle1", color: 'textSecondary', component: 'span' }, { children: t('arcade.winUpto', {
                                            points: denominations[selectedWagerIndex].topPrizeValue.toPointsFormat()
                                        }) })), (0, jsx_runtime_1.jsx)(ArcadeCurrency_1.default, { color: 'secondary', size: 18 })] })), (0, jsx_runtime_1.jsxs)(core_1.Button, Object.assign({ variant: 'contained', color: 'primary', className: classes.detailButton, onClick: launchGame }, { children: [t('arcade.button.playFor', {
                                        amount: denominations[selectedWagerIndex].value.toPointsFormat()
                                    }), (0, jsx_runtime_1.jsx)(ArcadeCurrency_1.default, { color: 'secondary', size: 16 })] }))] })) : ((0, jsx_runtime_1.jsx)(ArcadeNotification_1.default, { children: (0, jsx_runtime_1.jsx)(core_1.Typography, Object.assign({ variant: "body1", color: 'textPrimary' }, { children: (0, jsx_runtime_1.jsxs)(react_i18next_1.Trans, Object.assign({ i18nKey: "arcade.notEnoughPointsForWager" }, { children: ["a", (0, jsx_runtime_1.jsx)(core_1.Typography, Object.assign({ variant: "body1", component: 'a', href: "/lucky-lounge/store", className: classes.buyLink }, { children: "Buy points" })), "a"] })) })) })), playForFunContainer()] }))) : ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: classes.detailBtnContainer }, { children: [howToPlayContainer(), (0, jsx_runtime_1.jsx)(ArcadeNotification_1.default, { children: (0, jsx_runtime_1.jsx)(core_1.Typography, Object.assign({ variant: "body1", color: 'textPrimary' }, { children: (0, jsx_runtime_1.jsxs)(react_i18next_1.Trans, Object.assign({ i18nKey: "arcade.notEnoughPoints" }, { children: ["a", (0, jsx_runtime_1.jsx)(core_1.Typography, Object.assign({ variant: "body1", component: 'a', href: "/lucky-lounge/store", className: classes.buyLink }, { children: "Buy points" })), "a"] })) })) }), playForFunContainer()] }))), (0, jsx_runtime_1.jsx)(InformationDialog_1.default, Object.assign({ open: howToPlay, onClose: hideHowToPlay, maxWidth: 'xs', hideButton: true, hideXButton: true }, { children: (0, jsx_runtime_1.jsxs)(Grid_1.default, Object.assign({ container: true, spacing: 2, className: classes.howToPlayDialog }, { children: [(0, jsx_runtime_1.jsx)(Grid_1.default, Object.assign({ item: true, xs: 12 }, { children: (0, jsx_runtime_1.jsx)(core_1.Typography, Object.assign({ variant: "h5" }, { children: t('arcade.howToPlay') })) })), (0, jsx_runtime_1.jsx)(Grid_1.default, Object.assign({ item: true, xs: 12 }, { children: (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(core_1.Typography, Object.assign({ variant: "body1", className: classes.howToPlayDialogText }, { children: (0, jsx_runtime_1.jsx)("span", { dangerouslySetInnerHTML: { __html: howToPlayText } }) })) }) })), (0, jsx_runtime_1.jsx)(Grid_1.default, Object.assign({ item: true, xs: 12 }, { children: (0, jsx_runtime_1.jsx)(ArcadePopupButton_1.default, { title: 'CLOSE', onSubmit: hideHowToPlay, className: classes.infoButton }) }))] })) }))] })));
};
const styles = (theme) => (0, core_1.createStyles)({
    detailButton: {
        paddingLeft: theme.spacing() * 10,
        paddingRight: theme.spacing() * 10
    },
    arcadeCurrency: {
        marginLeft: theme.spacing() - 3,
        fontSize: 14,
        alignSelf: 'flex-end'
    },
    detailBtnContainer: {
        width: '100%',
        background: 'linear-gradient(180deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0.4) 35%, rgba(0,0,0,0.7) 55%, rgba(0,0,0,0.8) 75%, rgb(0, 0, 0) 100%)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        height: '100%'
    },
    winningAmount: {
        marginBottom: theme.spacing(5),
        display: 'flex',
        justifyContent: 'center'
    },
    buyLink: {
        color: theme.palette.primary.main
    },
    forFunContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        marginTop: theme.spacing(2)
    },
    howToPlayDialog: {
        color: theme.palette.common.black,
        textAlign: 'center',
        paddingTop: theme.spacing(3),
        paddingBottom: theme.spacing(3)
    },
    infoButton: {
        minWidth: '10%'
    },
    howtoPlayButton: {
        display: 'flex',
        justifyContent: 'center',
        minWidth: '10%',
        marginBottom: '9vh',
        alignItems: 'center'
    },
    howToPlayDialogText: {
        textAlign: 'left'
    },
    logoContainer: {
        marginBottom: theme.spacing(2),
        width: '16%',
        [theme.breakpoints.down('md')]: {
            width: '40%'
        },
        [theme.breakpoints.down('xs')]: {
            width: '60%'
        },
        display: 'flex',
        justifyContent: 'center'
    },
    howToPlayBg: {
        backgroundColor: color(theme.palette.common.black).alpha(0.65).rgb().string()
    }
});
exports.default = (0, styles_1.withStyles)(styles)((0, react_i18next_1.withTranslation)()(ArcadeDetails));
//# sourceMappingURL=ArcadeDetails.js.map